export const Events = {
  configurationChangesClicked: 'configuration_changes_clicked',
  configurationPageView: 'configuration_initial_viewed',
  contentFetchFailed: 'content_fetch_failed',
  communitySupportClicked: 'community_support_cta_clicked',
  developerDocsClicked: 'developer_docs_cta_clicked',
  errorStateViewed: 'error_state_viewed',
  ineligibleStateViewed: 'ineligible_state_viewed',
  learnMoreClicked: 'learn_more_clicked',
  publishButtonClicked: 'publish_button_clicked',
  previewBundleErrorStateViewed: 'preview_bundle_error_state_viewed'
};

export const LifeCycleProducts = {
  messageCenter: 'message_center',
  partnerMessagingConfigurator: 'partner_messaging_configurator'
};

export const PreviewColors = {
  dark: 'dark',
  light: 'light'
};

export const StyleCustomizations = {
  button: 'button_customized',
  font: 'misc_font_customized',
  header: 'header_customized',
  subheader: 'subheader_customized',
  toggle: 'toggle_customized'
};

export const EventCounters = {
  desktopPreviewClicked: 'desktop_preview_clicked',
  messagePreviewClicked: 'message_preview_clicked',
  mobilePreviewClicked: 'mobile_preview_clicked',
  previewArrowLeftClicked: 'preview_arrow_left_clicked',
  previewArrowRightClicked: 'preview_arrow_right_clicked',
  previewColorClicked: 'preview_color_clicked',
  resetCustomizationsClicked: 'reset_customizations_clicked',
  totalConfigsUpdated: 'total_configs_updated'
};

export const ConfigsUpdatedCounter = 'configs_updated';

export const TextColorLabels = {
  black: 'black_blue_logo',
  grayscale: 'graysblack_gray_logo',
  monochrome: 'monochrome',
  white: 'white_white_logo'
};

export const TextSizeLabels = {
  10: 'small',
  12: 'medium',
  16: 'large'
};

export const BannerColorLabels = {
  black: 'black',
  blue: 'blue',
  gray: 'gray',
  monochrome: 'monochrome',
  white: 'white',
  'white-no-border': 'white_no_border'
};

export const LogoTypeLabels = {
  alternative: 'monogram',
  inline: 'inline',
  none: 'message_only',
  primary: 'full_logo'
};
